(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bk-retired-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const retiredForm = '[data-testid="klaviyo-form-RnQhyj"]';
  const popupSelector = '[role="dialog"]:has([data-testid^="klaviyo-form-"])';
  const lockClass = 'klaviyo-prevent-body-scrolling';
  let queued = false;
  const isVisible = element => {
    const style = getComputedStyle(element);
    return element.getClientRects().length > 0 && style.visibility !== 'hidden' &&
      !style.animationName?.includes('klaviyo-fadeout');
  };
  const releaseRetiredLock = () => {
    queued = false;
    if (!document.body.classList.contains(lockClass)) return;
    const retired = document.querySelector(retiredForm)?.closest('[role="dialog"]');
    if (!retired || isVisible(retired)) return;
    if ([...document.querySelectorAll(popupSelector)].some(isVisible)) return;
    document.body.classList.remove(lockClass);
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(releaseRetiredLock);
  };
  new MutationObserver(mutations => {
    if (mutations.some(mutation => mutation.type === 'childList' || mutation.target === document.body ||
      mutation.target.matches?.('[role="dialog"]'))) schedule();
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'aria-hidden']});
  schedule();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bk-start-box"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const link = event.target.closest('[data-bk-start-box]');
    if (!link) return;
    const form = link.closest('form');
    const variant = form?.querySelector('[name="id"]')?.value;
    if (!variant) return;
    const address = new URL(link.href);
    address.searchParams.delete('box_product');
    address.searchParams.set('box_variant', variant);
    address.searchParams.set('box_quantity', form.querySelector('[name="quantity"]')?.value || '1');
    link.href = address.href;
  });
  } catch(e) { console.error(e); }
})();

})();
